export const siteContent = {
  brand: {
    name: "Sasmita & Sangram",
    tagLine: "Playback Singers | Facebook Live Stars | Concert Performers",
    heroSubtext:
      "Playback singers, Facebook & YouTube Live performers, and concert artists bringing soulful music to stages across India and abroad.",
    primaryCta: "Book / Contact",
    accent: "#f4c36b",
    heroImage: "/assets/duo-banner.jpg",
    logo: "/assets/logo.svg"
  },
  contact: {
    whatsapp: "+91-7894873687",
    whatsappUrl: "https://wa.me/917894873687",
    email: "ssentertainmentoficial@gmail.com"
  },
  socials: [
    {
      name: "Facebook",
      url: "https://www.facebook.com/sasmitasangram",
      icon: "/assets/facebook.png"
    },
    {
      name: "YouTube",
      url: "https://www.youtube.com/@SasmitaSangram",
      icon: "/assets/youtube.png"
    },
    {
      name: "Instagram",
      url: "https://www.instagram.com/SasmitaSangram_official",
      icon: "/assets/instagram.png"
    }
  ],
  artists: [
    {
      name: "Sasmita Biswal",
      role: "Playback Singer & Performer",
      image: "/assets/sasmita.jpg",
      highlight:
        "Magical voice that touches the heart of the audience. Versatile singer with 400+ songs across films, albums, and bhajans; known for live sessions and concerts in India and abroad.",
      achievements: [
        "400+ songs in films, albums, bhajans",
        "Reality shows, Odia movies & TV",
        "International concerts (Malaysia, Dubai)",
        "Facebook & YouTube live",
        "Movies: Rudra, Premi Deewana, Yeh Dil Tate Deli, Ram Naam Satya Hai",
        "TV: Weekend Classic Shows, Smruti Tume"
      ],
      awards: [
        "Nirmalya Award 2019",
        "Adarsha Award 2019",
        "Maa Shyamakali Sammana",
        "Maa Chandi Sammana",
        "Swaraoke Award",
        "Maa Tarini Sammana",
        "Satasahi Festival Awards",
        "Amari Geeta Amari Swara Sammana"
      ]
    },
    {
      name: "Sangram Mohanty",
      role: "Singer & Performer",
      image: "/assets/sangram.jpg",
      highlight:
        "Brilliant voice that creates a magical aura. 1000+ concerts, renowned playback singer with 60+ films and 70+ albums; viral Bollywood covers and stage charisma.",
      achievements: [
        "1000+ concerts worldwide",
        "60+ films, 70+ albums",
        "Bollywood covers (Mohd. Rafi songs) viral on social media",
        "Movies: Smile Please (\"Re Sajani\")",
        "TV: Weekend Classic Shows, Smruti Tume"
      ],
      awards: [
        "Best Male Singer Award",
        "Radio Chocolate Award (Best Male Singer)",
        "Chalachitra Jagat Award (Best Male Singer)",
        "Adarsha Sammana 2019",
        "Nirmalya Award 2019",
        "And many more…"
      ]
    }
  ],
  concerts:
    "Faridabad Odia Community, Delhi | Jodhpur Indana Palace (Weddings) | Raja Mahotsav, Gurugram | Surat & Durgapur Odia Associations | Malaysia Odia Community and more.",
  gallery: [
    "/assets/gallery1.jpg",
    "/assets/gallery2.jpg",
    "/assets/gallery3.jpg",
    "/assets/gallery4.jpg"
  ]
};
